import React from 'react';
import { Stats } from './types';

export const TeamHeaders = ({
  stats,
  homeId,
  awayId,
  getTeamName
}: {
  stats: Stats;
  homeId: string;
  awayId: string;
  getTeamName: (teamId: number | string) => string;
}) => (
  <div className="grid grid-cols-3 gap-2 mb-4 pb-4 border-b-2 border-gray-200 dark:border-gray-700">
    <div className="text-center">
      {stats.teams?.[homeId]?.team?.imageDataURL && (
        <img
          src={stats.teams[homeId].team?.imageDataURL}
          alt={getTeamName(homeId)}
          className="h-10 w-10 mx-auto mb-1"
        />
      )}
      <div className="font-semibold text-gray-900 dark:text-gray-100">{getTeamName(homeId)}</div>
      <div className="text-xs text-gray-500 dark:text-gray-400">Home</div>
    </div>
    <div className="flex items-center justify-center">
      <span className="text-gray-400 dark:text-gray-500">vs</span>
    </div>
    <div className="text-center">
      {stats.teams?.[awayId]?.team?.imageDataURL && (
        <img
          src={stats.teams[awayId].team?.imageDataURL}
          alt={getTeamName(awayId)}
          className="h-10 w-10 mx-auto mb-1"
        />
      )}
      <div className="font-semibold text-gray-900 dark:text-gray-100">{getTeamName(awayId)}</div>
      <div className="text-xs text-gray-500 dark:text-gray-400">Away</div>
    </div>
  </div>
);
